import React from 'react';
import './Banner.css'
import videoBtn from '../../../Assets/Icons/right-arrow.png'


const Banner = () => {
    return (
        <div className='pb-28 pt-28 flex mx-auto justify-center w-screen lg:w-full items-center' >
            <div className='text-center'>
                <h4 className='mb-3 md:mb-7 text-sm md:text-xl text-primary font-semibold font-mono' data-aos="fade-up">Hi, my name is</h4>
                <h1 className='text-4xl md:text-7xl mb-3 md:mb-7 font-style' data-aos="fade-up"> <span className='transition-headline'>S</span>
                    <span className='transition-headline'>y</span>
                    <span className='transition-headline'>e</span>
                    <span className='transition-headline'>d</span>
                    <span className='transition-headline'>a</span>
                    <span className='transition-headline'> </span>
                    <span className='transition-headline'>A</span>
                    <span className='transition-headline'>i</span>
                    <span className='transition-headline'>s</span>
                    <span className='transition-headline'>h</span>
                    <span className='transition-headline'>a</span>
                    <span className='transition-headline'> </span>
                    <span className='transition-headline'>A</span>
                    <span className='transition-headline'>h</span>
                    <span className='transition-headline'>m</span>
                    <span className='transition-headline'>a</span>
                    <span className='transition-headline'>d</span></h1>
                <h3 className='md:text-3xl mt-[-10px] font-light' data-aos="fade-up">Front End Developer</h3>

                <div className='flex items-center justify-center gap-4 mt-7' data-aos="fade-up">
                    {/* <div className='bg-secondary hover:bg-primary hover:shadow-xl hover:shadow-sky-100 transition-colors duration-500 cursor-pointer text-white px-16 py-3 rounded-full text-lg font-semibold' >Hire Me</div> */}
                    <a href='#contact' className='hover:bg-base-100 text-base'>
                        <div className='bg-secondary hover:bg-primary hover:shadow-lg hover:shadow-secondary transition-colors duration-500 cursor-pointer text-white px-16 py-3 rounded-full text-lg font-semibold' >Hire Me</div>
                    </a>
                    {/* <div className='bg-[#CCE9FF] hover:bg-sky-200 hover:shadow-xl hover:shadow-sky-100 transition-colors duration-500 cursor-pointer  p-4 rounded-full text-center vid'><img className='ml-1 w-5 rounded-none ' src={videoBtn} alt="" /></div> */}
                </div>
            </div>
        </div>

    );
};

export default Banner;